import {scoreBadge} from "../../utilities/general"

export const AssessedScoresRow = ({osr, nhsr}) => {
    const preceptorAssessed = osr?.answers?.find(
        (answer) => answer.question_text && answer.question_text.includes("readiness for independent practice")
    )
    const preceptorBadge = scoreBadge(preceptorAssessed?.answer, preceptorAssessed?.max_answer_value)

    const selfAssessed = nhsr?.answers?.find(
        (answer) => answer.question_text && answer.question_text.includes("readiness for independent practice")
    )
    const selfBadge = scoreBadge(selfAssessed?.answer, selfAssessed?.max_answer_value)

    return (
        <div className="row row-cols-1 row-cols-lg-2 g-10 mb-8">
            <div className="col">
                <div className="d-flex flex-column w-100 gap-5">
                    <div className="d-flex align-items-center w-100 flex-column">
                        <div className="d-flex justify-content-between w-100 mb-2">
                            <span className="fw-bold fs-5">Preceptor-Assessed Readiness</span>
                            <div className="fw-bold fs-5">
                                {preceptorAssessed ? preceptorBadge.width + "%" : "Missing"}
                            </div>
                        </div>
                        {preceptorAssessed && (
                        <div className="h-10px mx-3 rounded w-100 bg-secondary">
                            <div
                                className={`${preceptorBadge?.color} rounded h-10px`}
                                role="progressbar"
                                style={{
                                    width: `${preceptorBadge?.width}%`,
                                }}
                            ></div>
                        </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="d-flex flex-column w-100 gap-5">
                    <div className="d-flex align-items-center w-100 flex-column">
                        <div className="d-flex justify-content-between w-100 mb-2">
                            <span className="fw-bold fs-5">Self-Assessed Readiness</span>
                            <div className="fw-bold fs-5">
                                {selfAssessed ? selfAssessed?.answer * 10 + "%" : "Missing"}
                            </div>
                        </div>
                        {selfAssessed && (
                        <div className="h-10px mx-3 rounded w-100 bg-secondary">
                            <div
                                className={`${selfBadge?.color} rounded h-10px`}
                                role="progressbar"
                                style={{
                                    width: `${selfBadge?.width}%`,
                                }}
                            ></div>
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
